import type { ILine } from '../../../../models/line.model';
import type { TransportMode } from '../../../../models/transport-mode.enum';
import type { TransportSubMode } from '../../../../models/transport-sub-mode.enum';

export class LineApiModel {
  public static mapToBusinessModel(apiModel: LineApiModel): ILine {
    return {
      gid: apiModel.gid,
      technicalLineNumber: undefined,
      shortName: apiModel.shortName,
      isWheelchairAccessible: apiModel.isWheelchairAccessible,
      name: apiModel.name,
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      transportMode: apiModel.transportMode,
      transportSubMode: apiModel.transportSubMode,
      contractorId: undefined,
      isPublicTransport: apiModel.IsPublicTransport,
      directionName: undefined,
      borderColor: apiModel.borderColor,
      municipalities: undefined,
      appliesFrom: undefined,
      appliesUpto: undefined,
      designation: apiModel.designation,
      transportAuthorityGid: undefined,
    };
  }

  public gid!: string;
  public shortName!: string;
  public isWheelchairAccessible!: boolean;
  public name!: string;
  public backgroundColor!: string;
  public foregroundColor!: string;
  public borderColor!: string;
  public transportMode!: TransportMode;
  public transportSubMode!: TransportSubMode;
  public IsPublicTransport!: boolean;
  public designation!: string | undefined;
}
